import { dataResponse, errorResponse, successResponse } from './utils/response-templates.js';
import { z } from './utils/zod.js';
import { planIntervalSchema } from './pricing-catalogue.js';
export const billingAddressSchema = z.object({
    address: z
        .object({
        city: z.string().nullable(),
        country: z.string().nullable(),
        line1: z.string().nullable(),
        line2: z.string().nullable(),
        postal_code: z.string().nullable(),
        state: z.string().nullable(),
    })
        .nullable(),
});
export const billingAddressUpdateRequestSchema = z.object({
    address: z
        .object({
        city: z.string().optional(),
        country: z.string().optional(),
        line1: z.string().optional(),
        line2: z.string().optional(),
        postal_code: z.string().optional(),
        state: z.string().optional(),
    })
        .optional(),
});
export const billingAddressResponseSchema = successResponse().extend({
    billingAddress: billingAddressSchema,
});
export const billingAddressUpdateResponseSchema = successResponse().extend({
    billingAddress: billingAddressSchema.nullable(),
});
export const billingAddressInvalidResponseSchema = errorResponse('Invalid request for get billing address');
export const quoteSubscriptionRequestSchema = z.object({
    interval: planIntervalSchema,
});
export const quoteSubscriptionResponseSchema = successResponse().extend({
    subtotal: z.number(),
    tax: z.number(),
    total: z.number(),
    currency: z.string(),
});
export const quoteSubscriptionInvalidResponseSchema = errorResponse('Invalid request for quote subscription');
export const billingPublicConfigResponseSchema = dataResponse(z.object({
    stripePublishableKey: z.string(),
}));
export const vatPreviewRequestSchema = z.object({
    netCents: z.number().int().positive(),
});
export const vatPreviewResponseSchema = dataResponse(z.object({
    ratePercent: z.number().nullable().openapi({ description: 'null when the customer cannot be placed for tax yet' }),
    reverseCharge: z.boolean(),
}));
